export default function CsharpMethodParameters() {
  return (
    <h2>Csharp Method Parameters</h2>
  );
}
